interface ValueCard {
  imageUrl: string;
  alt: string;
  label: string;
}

const values: ValueCard[] = [
  {
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20warm%20rose%20abstract%20geometric%20composition%2C%20flowing%20organic%20shapes%20with%20subtle%20gradient%2C%20minimalist%20contemporary%20aesthetic%2C%20no%20people%2C%20no%20text%2C%20smooth%20curves%20and%20rounded%20forms%2C%20gentle%20pastel%20warm%20tones%2C%20serene%20atmosphere%2C%20soft%20diffused%20lighting&width=500&height=600&seq=values-card-01&orientation=portrait',
    alt: 'Abstract composition representing technical excellence',
    label: 'Technical Excellence',
  },
  {
    imageUrl: 'https://readdy.ai/api/search-image?query=Mint%20green%20abstract%20layered%20forms%2C%20ethereal%20translucent%20overlapping%20shapes%2C%20serene%20atmosphere%20with%20soft%20gradients%2C%20minimalist%20contemporary%20aesthetic%2C%20no%20people%2C%20no%20text%2C%20gentle%20organic%20curves%2C%20clean%20and%20calm%20composition&width=500&height=600&seq=values-card-02&orientation=portrait',
    alt: 'Abstract composition representing user-centered design',
    label: 'User-Centered Design',
  },
  {
    imageUrl: 'https://readdy.ai/api/search-image?query=Light%20warm%20gray%20minimalist%20abstract%20texture%2C%20subtle%20wave%20patterns%20and%20gentle%20undulating%20forms%2C%20soft%20matte%20surface%2C%20elegant%20and%20refined%2C%20no%20people%2C%20no%20text%2C%20contemporary%20aesthetic%20with%20diffused%20lighting%2C%20smooth%20gradient%20transitions&width=500&height=600&seq=values-card-03&orientation=portrait',
    alt: 'Abstract composition representing continuous innovation',
    label: 'Continuous Innovation',
  },
  {
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20yellow-brown%20abstract%20organic%20forms%2C%20gentle%20flowing%20curves%20with%20earthy%20undertones%2C%20minimalist%20composition%2C%20no%20people%2C%20no%20text%2C%20soft%20natural%20texture%2C%20warm%20and%20grounded%20atmosphere%2C%20elegant%20and%20timeless%20aesthetic&width=500&height=600&seq=values-card-04&orientation=portrait',
    alt: 'Abstract composition representing long-term quality',
    label: 'Long-Term Quality',
  },
];

export default function ValuesSection() {
  return (
    <section className="w-full py-24 md:py-32 px-10 md:px-16 bg-background-200/70">
      <div className="w-full max-w-[1440px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div>
            <span className="text-sm text-foreground-500 font-serif italic tracking-wide">
              Our principles
            </span>
            <h2 className="mt-3 text-5xl md:text-6xl lg:text-7xl font-bold text-foreground-950 leading-[1.05]">
              Values That
              <br />
              <span className="font-serif italic font-medium">Define Our Work</span>
            </h2>
          </div>
          <div className="hidden lg:block">
            <div className="w-px h-24 bg-secondary-300"></div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((value) => (
            <div
              key={value.label}
              className="rounded-3xl overflow-hidden flex flex-col h-[420px] md:h-[480px]"
            >
              <div className="flex-1 overflow-hidden">
                <img
                  src={value.imageUrl}
                  alt={value.alt}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="h-[15%] min-h-[60px] bg-background-50 flex items-center px-5">
                <span className="text-base font-semibold text-foreground-900 font-serif">
                  {value.label}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}